import { render, staticRenderFns } from "./DhlShipmentTrackingPopUp.vue?vue&type=template&id=0b639418&scoped=true&"
import script from "./DhlShipmentTrackingPopUp.vue?vue&type=script&lang=js&"
export * from "./DhlShipmentTrackingPopUp.vue?vue&type=script&lang=js&"
import style0 from "./DhlShipmentTrackingPopUp.vue?vue&type=style&index=0&id=0b639418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b639418",
  null
  
)

export default component.exports